import Stickynode from 'react-stickynode';
import { isMobile } from 'react-device-detect';
import styles from './WebinarsAside.module.scss';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const WebinarsAside = () => {
  const webinarsList = useSelector((state) => state.webinars.webinars);

  return (
    <aside className={styles.aside}>
      {isMobile ? (
        <div>mobile</div>
      ) : (
        <Stickynode disable={isMobile} top={100}>
          <ul className={styles.list}>
            {webinarsList.map((item) => {
              return (
                <li key={item.id} className={styles.item}>
                  <Link to={'/webinars/' + item.id} className={styles.link}>
                    <span className={styles.name}>{item.title}</span>
                    <span className={styles.image}>
                      <img src={item.cover} alt="" />
                    </span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </Stickynode>
      )}
    </aside>
  );
};

export default WebinarsAside;
